// Observe the section: Searchanise can replace its mount or insert results beside it.
function mountSearchanise(root) {
  if (root.dataset.egdBound) return
  const scope = root.closest('.shopify-section') || root
  const native = root.querySelector('[data-egd-native-results]')
  if (!native) return
  root.dataset.egdBound = 'true'
  const refresh = () => {
    const candidates = scope.querySelectorAll('.snize-search-results-content, .snize-no-products-found, .snize-no-results, .snize-search-results-zero')
    const ready = Array.from(candidates).some(result => {
      if (native.contains(result) || result.closest('#snize_skeleton_results, .snize-skeleton-card, [hidden]')) return false
      // Empty containers and the app's skeleton are not completed results.
      if (result.matches('.snize-search-results-content')) return Boolean(result.querySelector('a[href]'))
      return Boolean(result.textContent.trim())
    })
    if (native.hidden !== ready) native.hidden = ready
  }
  const observer = new MutationObserver(refresh)
  observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] })
  refresh()
  const unload = event => {
    if (event.target === root || event.target.contains(root)) {
      observer.disconnect()
      delete root.dataset.egdBound
      document.removeEventListener('shopify:section:unload', unload)
    }
  }
  document.addEventListener('shopify:section:unload', unload)
}
function mountResults(scope) {
  if (scope.matches?.('[data-egd-results]')) mountSearchanise(scope)
  scope.querySelectorAll('[data-egd-results]').forEach(mountSearchanise)
}
mountResults(document)
document.addEventListener('shopify:section:load', event => mountResults(event.target))
